<template>
  <svg
    width="145"
    height="211"
    viewBox="0 0 145 211"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Isolation_Mode" clip-path="url(#clip0_2787_13564)">
      <path
        id="Vector"
        opacity="0.08"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M92.9993 206.116C81.6917 212.626 63.3499 212.626 52.0422 206.116C40.7346 199.607 40.7346 189.416 52.0422 182.896C63.3499 176.386 81.6917 176.386 92.9993 182.896C104.307 189.405 104.307 199.596 92.9993 206.116Z"
        fill="black"
      />
      <path
        id="Vector_2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.2596 199.152C80.4646 204.796 64.5768 204.796 54.7818 199.152C44.9868 193.508 44.9868 184.361 54.7818 178.727C64.5768 173.083 80.4646 173.083 90.2596 178.727C100.055 184.372 100.055 193.518 90.2596 199.152Z"
        fill="#43BCFF"
      />
      <path
        id="Vector_3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.09 123.551C118.09 123.551 115.435 154.135 96.6599 192.717H48.3407C29.5652 154.125 26.9102 123.551 26.9102 123.551H118.09Z"
        fill="#43BCFF"
      />
      <path
        id="Vector_4"
        d="M72.521 150.97C97.7289 150.97 118.164 139.204 118.164 124.69C118.164 110.176 97.7289 98.4102 72.521 98.4102C47.313 98.4102 26.8779 110.176 26.8779 124.69C26.8779 139.204 47.313 150.97 72.521 150.97Z"
        fill="#8FD4FF"
      />
      <path
        id="Vector_5"
        d="M72.5214 148.545C95.8424 148.545 114.748 137.742 114.748 124.417C114.748 111.091 95.8424 100.289 72.5214 100.289C49.2003 100.289 30.2949 111.091 30.2949 124.417C30.2949 137.742 49.2003 148.545 72.5214 148.545Z"
        fill="#399EFF"
      />
      <path
        id="Vector_6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M102.498 126.876C85.9441 117.338 59.0977 117.338 42.5435 126.876C38.7567 129.059 35.8372 131.528 33.7852 134.145C35.8372 136.761 38.7567 139.23 42.5435 141.413C59.0977 150.951 85.9441 150.951 102.498 141.413C106.285 139.23 109.205 136.761 111.257 134.145C109.205 131.528 106.285 129.059 102.498 126.876Z"
        fill="#143684"
      />
      <path
        id="Vector_7"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M98.5639 174.255C84.157 182.547 60.7907 182.547 46.3838 174.255C40.9997 171.153 37.636 167.344 36.2715 163.346C36.4196 163.81 37.5725 167.745 39.8891 173.347C41.2959 176.639 44.4375 179.741 48.9013 182.315C61.9437 189.826 83.0781 189.826 96.1205 182.315C100.521 179.783 103.599 176.776 105.027 173.537C107.83 167.186 108.888 162.66 108.888 162.66C107.693 166.912 104.255 170.995 98.5639 174.276V174.255Z"
        fill="#E3F3FF"
      />
      <path
        id="Vector_8"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M102.806 155.518C86.0503 165.172 58.8761 165.172 42.1209 155.518C35.8694 151.921 31.9451 147.479 30.3584 142.827C30.5276 143.365 31.5325 148.766 33.4365 154.326C35.0761 158.156 39.8572 161.891 45.0509 164.876C60.2194 173.612 84.8022 173.612 99.9707 164.876C105.09 161.933 109.829 158.335 111.49 154.569C112.696 151.552 114.811 142.004 114.811 142.004C113.415 146.952 109.427 151.699 102.806 155.508V155.518Z"
        fill="#F62121"
      />
      <g id="Group">
        <path
          id="Vector_9"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M61.8582 95.6245C61.8582 95.6245 67.4116 87.0896 65.1479 73.3957C62.8843 59.7018 68.0251 66.401 68.9982 71.3912C69.9714 76.3813 69.7281 93.3774 73.2716 99.4225C68.9982 100.625 61.8477 95.614 61.8477 95.614L61.8582 95.6245Z"
          fill="#FF590E"
        />
        <path
          id="Vector_10"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.1244 72.1736C84.1244 72.1736 67.6125 35.4069 86.8112 46.9591C106.01 58.5219 84.1244 72.1736 84.1244 72.1736Z"
          fill="#009573"
        />
        <path
          id="Vector_11"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M86.2717 82.4486C86.2717 82.4486 70.4897 54.9975 79.65 60.4202C88.8103 65.8429 89.8999 77.5851 89.8999 77.5851L86.2823 82.4486H86.2717Z"
          fill="#009573"
        />
        <path
          id="Vector_12"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M88.2715 39.1505C88.2715 39.1505 109.427 11.0136 113.954 17.1537C115.573 19.3481 113.806 27.2817 116.207 29.8348C120.534 34.4452 127.896 29.4339 126.849 39.1505C125.22 54.2686 95.1576 65.2723 95.1576 65.2723L88.2715 39.1505Z"
          fill="#009573"
        />
        <path
          id="Vector_13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M98.1406 67.8268C98.1406 67.8268 108.74 94.2334 116.165 93.5793C123.591 92.9358 118.704 82.0693 121.422 82.4491C124.141 82.8183 124.5 73.049 128.488 73.8719C132.476 74.6948 144.767 76.3195 143.329 71.4454C141.89 66.5713 128.129 66.2021 130.477 61.866C132.836 57.53 150.395 51.5692 140.801 45.4291C131.207 39.289 109.004 57.2557 109.004 57.2557L98.1512 67.8268H98.1406Z"
          fill="#009573"
        />
        <path
          id="Vector_14"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.615 61.8672C22.615 61.8672 2.31624 64.3042 7.92245 72.1851C13.5287 80.0554 29.3636 73.8731 29.3636 73.8731L22.6255 61.8672H22.615Z"
          fill="#009573"
        />
        <path
          id="Vector_15"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.2395 72.037C49.2395 72.037 39.9946 86.079 33.8912 84.9923C27.7878 83.9057 34.3566 72.3007 23.1019 68.7137C11.8471 65.1267 -6.6428 57.71 2.42235 50.1246C11.4769 42.5391 20.1084 39.8594 30.464 47.0651C40.8196 54.2708 41.7822 44.6386 46.2566 47.4343C50.7204 50.2301 49.2395 72.0264 49.2395 72.0264V72.037Z"
          fill="#009573"
        />
        <path
          id="Vector_16"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M113.531 28.1794C114.43 27.3459 115.869 26.9872 116.852 27.7152C117.392 28.1161 117.984 28.8229 118.566 28.4853C118.925 28.2743 118.968 27.789 118.989 27.367C119.158 23.8117 120.65 19.8449 124.045 18.2307C126.013 17.3023 128.668 17.6188 130.36 18.9903C132.454 20.6889 132.148 23.2631 131.153 25.4997C130.455 27.0716 129.524 28.4748 128.445 29.8041C128.012 30.3421 126.552 31.682 127.049 32.4838C127.388 33.0324 128.943 32.9269 129.546 33.2961C130.445 33.8447 131.1 34.8048 131.333 35.8176C132.359 40.1642 128.308 43.7617 124.891 45.5552C116.281 50.0812 114.483 52.1384 114.483 52.1384C113.351 48.2033 112.283 44.2259 111.775 40.1536C111.341 36.6616 110.738 31.2178 113.34 28.3587C113.393 28.2954 113.457 28.2321 113.52 28.1794H113.531Z"
          fill="#23C190"
        />
        <path
          id="Vector_17"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M63.3607 138.766C63.3607 138.766 61.8692 124.418 72.595 104.141C82.5381 85.3515 89.6252 70.803 86.7269 46.2426C83.8286 21.6822 91.4446 42.6556 91.4446 42.6556C91.4446 42.6556 99.7905 72.6493 91.4446 90.0146C83.0988 107.38 77.3021 113.657 77.6618 126.053C78.0214 138.45 77.4714 137.511 77.4714 137.511C77.4714 137.511 70.8391 144.453 63.3607 138.756V138.766Z"
          fill="#FF782D"
        />
        <path
          id="Vector_18"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.8686 54.6181C50.8686 54.6181 54.6766 94.5815 76.6783 100.7C79.3862 108.782 74.7955 116.789 68.4911 110.28C62.1868 103.771 47.7481 89.5913 46.2461 54.6392C48.4145 41.9897 50.8686 54.6181 50.8686 54.6181Z"
          fill="#FF782D"
        />
        <path
          id="Vector_19"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M94.7028 61.8664C94.7028 61.8664 102.012 61.9614 111.352 51.9283C120.692 41.9058 117.17 49.7234 116.07 54.6186C114.906 59.7881 102.076 68.0487 95.1471 75.3282C89.8899 80.8459 94.6922 61.8664 94.6922 61.8664H94.7028Z"
          fill="#FF590E"
        />
        <path
          id="Vector_20"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.2806 50.125C38.2806 50.125 42.4482 57.9742 43.1146 58.7022C46.2668 62.1626 45.9283 63.2703 48.8689 65.2748C51.0374 66.7624 51.6403 72.9868 49.2391 72.0268C43.6647 69.8113 36.2285 56.2862 36.9266 52.0346L38.2912 50.125H38.2806Z"
          fill="#FF590E"
        />
        <path
          id="Vector_21"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M119.233 33.9941C119.687 34.184 120.132 34.5111 120.597 34.7748C124.119 36.7688 127.293 35.7982 129.599 32.6121C131.725 29.6792 132.941 26.2504 134.824 23.1909C135.924 21.408 139.51 14.983 142.292 17.8948C144.302 20.0048 145.264 22.7478 144.937 25.6385C144.788 26.9995 144.386 28.4132 143.847 29.6686C143.149 31.2722 141.753 32.6543 141.636 34.4689C141.541 35.9564 142.398 37.3279 143.138 38.6256C143.879 39.9232 144.545 41.453 144.08 42.8667C143.762 43.8056 142.98 44.5441 142.102 44.9978C140.282 45.9473 138.04 46.1583 136.062 46.6014C134.993 46.8335 132.613 47.1183 132.275 48.4476C131.609 51.0957 138.664 58.4596 126.849 59.3563C115.023 60.2531 110.633 61.1393 110.633 61.1393C110.971 57.8582 111.437 54.5983 111.976 51.3489C112.886 45.9051 113.478 40.1026 116.482 35.3234C116.789 34.8381 117.128 34.3634 117.625 34.0785C118.238 33.7304 118.757 33.7831 119.243 33.9941H119.233Z"
          fill="#17A984"
        />
        <path
          id="Vector_22"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M51.767 48.9952C52.2219 48.7948 52.7614 48.6998 53.2691 48.5416C57.1406 47.3494 58.6003 44.3849 57.8598 40.5236C57.1723 36.9682 55.5116 33.7399 54.5702 30.269C54.0201 28.2434 51.7988 21.2382 55.8289 21.2171C58.7484 21.196 61.4034 22.3881 63.2968 24.6036C64.1853 25.6481 64.9469 26.9035 65.4864 28.159C66.174 29.7626 66.2269 31.7354 67.475 33.0542C68.5011 34.1408 70.0772 34.4573 71.5369 34.816C72.9966 35.1747 74.5727 35.7339 75.2814 37.0421C75.7574 37.9177 75.7468 38.9833 75.4824 39.9433C74.9218 41.9162 73.5467 43.6886 72.51 45.4293C71.9494 46.3683 70.5214 48.2884 71.2619 49.4383C72.7322 51.7382 82.9609 51.6644 75.5036 60.864C68.0462 70.0636 65.698 73.8616 65.698 73.8616C63.5401 71.3718 61.4669 68.787 59.4677 66.1706C56.1145 61.7818 52.2854 57.3719 50.8679 51.907C50.7199 51.3584 50.6035 50.7782 50.741 50.2296C50.8997 49.5544 51.3016 49.2062 51.7882 48.9952H51.767Z"
          fill="#009573"
        />
        <path
          id="Vector_23"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.0145 51.4633C15.3481 50.2395 15.3692 48.562 16.4376 47.6864C17.0299 47.2011 17.9819 46.758 17.7704 46.03C17.6434 45.5764 17.1145 45.397 16.6597 45.2599C12.7882 44.0677 8.84273 41.3247 8.02824 37.1364C7.55224 34.7099 8.65233 31.893 10.6515 30.4266C13.1056 28.612 15.8558 29.6775 18.0454 31.3972C19.5792 32.5999 20.8696 34.0136 22.0226 35.575C22.488 36.208 23.5564 38.1703 24.5719 37.8643C25.27 37.6533 25.5873 35.9126 26.1691 35.3534C27.0259 34.5305 28.2741 34.0769 29.4588 34.098C34.5361 34.1929 37.3604 39.6578 38.3758 43.9095C40.9357 54.6283 42.7022 57.1814 42.7022 57.1814C38.0479 57.308 33.362 57.3607 28.7395 56.7699C24.7728 56.2635 18.5954 55.3773 16.1837 51.727C16.1308 51.6426 16.0779 51.5582 16.0356 51.4738L16.0145 51.4633Z"
          fill="#23C190"
        />
        <path
          id="Vector_24"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M133.385 67.9216C134.189 68.9766 134.411 70.5485 133.544 71.5191C133.057 72.0572 132.232 72.6163 132.539 73.2704C132.729 73.6713 133.248 73.7663 133.692 73.8401C137.5 74.3993 141.604 76.4038 142.979 80.2123C143.773 82.4173 143.159 85.2236 141.498 86.8905C139.457 88.9477 136.717 88.3464 134.422 87.0487C132.814 86.1414 131.397 85.002 130.085 83.7044C129.556 83.1874 128.266 81.4889 127.356 81.932C126.732 82.2379 126.679 83.9154 126.224 84.5167C125.537 85.4135 124.436 86.0148 123.315 86.1731C118.534 86.8166 115.086 82.1008 113.52 78.2606C109.554 68.5757 107.533 66.434 107.533 66.434C111.881 65.6322 116.27 64.9148 120.703 64.7988C124.5 64.7038 130.423 64.63 133.216 67.7106C133.279 67.7739 133.332 67.8477 133.396 67.9216H133.385Z"
          fill="#23C190"
        />
        <path
          id="Vector_25"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M70.1726 23.3268C70.4159 21.7232 71.6323 20.1723 73.2401 20.1196C74.1287 20.0879 75.3345 20.3411 75.6519 19.5182C75.8528 19.0013 75.4932 18.4632 75.1759 18.0201C72.4256 14.1905 70.7015 8.85216 72.9122 4.38951C74.1921 1.80476 77.2068 -0.0414911 80.0945 0.000708875C83.6592 0.0534589 85.4574 2.97581 86.2719 6.10916C86.8431 8.30356 87.0335 10.5296 87.0018 12.7979C86.9912 13.7157 86.5893 16.2899 87.7528 16.7225C88.5567 17.0179 90.0905 15.6253 91.0108 15.5198C92.3965 15.3615 93.8668 15.8152 94.9563 16.6803C99.5999 20.3517 98.3517 27.4202 96.2785 32.0833C91.0531 43.836 90.8838 47.4546 90.8838 47.4546C86.4729 44.2896 82.0831 41.0402 78.2117 37.2211C74.8903 33.9506 69.7812 28.7811 70.1303 23.6855C70.1303 23.5694 70.1514 23.4639 70.1726 23.3479V23.3268Z"
          fill="#23C190"
        />
        <path
          id="Vector_26"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M91 47.4436C91 47.4436 91.1587 13.2299 96.9341 9.33698C102.71 5.43348 104.201 13.0189 102.561 19.7393C100.922 26.4596 107.681 27.1981 106.116 32.03C104.55 36.8619 91 47.4541 91 47.4541V47.4436Z"
          fill="#17A984"
        />
        <path
          id="Vector_27"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.9456 82.5552C68.9456 82.5552 63.6884 75.7821 65.5078 69.2305C67.3166 62.679 69.3158 66.3715 70.3947 59.5562C71.4842 52.7409 76.1913 40.8194 80.1791 50.7575C84.167 60.6956 77.3231 64.4303 79.2695 65.9284C86.695 71.6359 68.9456 82.5446 68.9456 82.5446V82.5552Z"
          fill="#17A984"
        />
        <path
          id="Vector_28"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.0164 67.2362C38.0164 67.2362 37.6568 74.6001 32.791 77.8706C27.9358 81.1411 28.6974 77.6174 24.1701 81.4681C19.6323 85.3189 9.86898 90.4884 12.8308 81.7635C15.7925 73.0387 22.3719 74.4102 21.9382 72.3424C20.2775 64.4721 38.0164 67.2362 38.0164 67.2362Z"
          fill="#17A984"
        />
        <path
          id="Vector_29"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M48.7002 58.342C48.7002 58.342 57.1095 47.4966 54.2112 37.0099C51.3129 26.5232 48.1184 32.4312 46.3836 21.5225C44.6383 10.6138 37.1069 -8.48173 30.718 7.42767C24.3396 23.3371 35.2981 29.3295 32.1671 31.7243C20.2777 40.8606 48.7002 58.342 48.7002 58.342Z"
          fill="#17A984"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2787_13564">
        <rect width="145" height="211" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
